<kendo-combobox
  [data]="data"
  [textField]="textField"
  [valueField]="valueField"
  [value]="currentValue"
  (valueChange)="onValueChange($event)">
</kendo-combobox>
